export default {
  applicationManagement: {
    unassignedApplications: null,
    assignedApplications: null,
    duplicates: null
  }
};
